import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import "./styles/nexline.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import TrustSection from "./components/TrustSection";
import PortfolioSection from "./components/PortfolioSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import { useSEO } from "./hooks/useSEO";

function HomePage() {
  useSEO(
    "Nexline Electrical Ltd. | Residential & Commercial Electrical Services",
    "Nexline Electrical Ltd. - Canada's elite residential and commercial electrical contractor. Licensed, insured, and engineered for excellence."
  );
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <TrustSection />
        <PortfolioSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-black">
      <Toaster theme="dark" richColors position="top-center" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
